import { TOASTER_STATE } from '../../../Model/Enums';
import { useAppSelector } from '../../../Store/store';
import { toasterMessageSelector } from '../../../Store/layoutSlice';

export const useToasterState = () => {
  const toasterMessage = useAppSelector(toasterMessageSelector);
  const state = {
    [TOASTER_STATE.ENTREPRENEUR_CREATION_SUCCESS]: {
      title: 'Sikeres regisztráció',
      message: 'A továbblépéshez a linket elküldtük Neked emailben. Kérjük lépj be az email fiókodba és kattints rá!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.ENTREPRENEUR_CREATION_FAILED]: {
      title: 'Sikertelen regisztráció',
      message: 'Érvénytelen vagy hiányzó email!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.ACCOUNTANT_AUTH_SUCCESS]: {
      title: 'Sikeres azonosítás',
      message: 'A továbblépéshez a linket elküldtük Neked emailben. Kérjük lépj be az email fiókodba és kattints rá!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.ACCOUNTANT_AUTH_FAILED]: {
      title: 'Sikertelen azonosítás',
      message: 'Ez az email cím nincs regisztrálva a rendszerünkben!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.ACCOUNTANT_CREATED_FAILED]: {
      title: 'Sikertelen mentés',
      message: 'A könyvelő mentése sikertelen volt!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.DELETE_ACCOUNTANT_FAILED]: {
      title: 'Sikertelen törlés',
      message: 'A könyvelő törlése sikertelen volt!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.DELETE_ACCOUNTANT_SUCCESS]: {
      title: 'Sikeres törlés',
      message: 'A könyvelő törlése megtörtént!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.COMPANY_CREATION_FAILED]: {
      title: 'Sikertelen mentés',
      message: 'A céget nem sikerült létrehozni! Próbálja újra!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.ENTREPRENEUR_SAVE_OR_EDIT_FAILED]: {
      title: 'Sikertelen mentés',
      message: 'A vállalkozó mentése sikertelen volt!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.FILE_UPLAOD_FAILED]: {
      title: 'Sikertelen fájlfeltöltés',
      message: 'A fájl(oka)t nem sikerült feltölteni!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.FILE_UPLAOD_TIMEOUT]: {
      title: 'Sikertelen fájlfeldolgozás',
      message:
        'A  fájl(oka)t nem sikerült feldolgozni időben! Ez nem azt jelenti, hogy a folyamat nem sikeres, mivel a fájlfeldolgozás időigényes feladat. Frissítse az oldalt pár perc múlva vagy térjen vissza később!',
      className: 'bg-info text-dark',
    },
    [TOASTER_STATE.AGGREG8_API_CONNECT_REVOKE_FAILED]: {
      title: 'Sikertelen visszavonás',
      message: 'Az Aggreg8 hozzáférés törlése meghiúsult!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.AGGREG8_API_CONNECT_FAILED]: {
      title: 'Sikertelen csatlakozás',
      message: 'Nem tudtunk csatlakozni az Aggreg8-hez, próbálja meg később!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.ENTREPRENEUR_SAVE_OR_EDIT_SUCCESS]: {
      title: 'Sikeres mentés',
      message: 'Az Ön által felvitt adatok sikeresen mentésre kerültek!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.EXPORT_FILES_EMPTY]: {
      title: 'Sikertelen exportálás',
      message: 'Az Ön által lekért időszakban az adott bankszámlá(k)hoz nem tartoznak tranzakciók!',
      className: 'bg-warning text-black',
    },
    [TOASTER_STATE.EXPORT_FILES_DATE_WARNING]: {
      title: 'Figyelmeztetés',
      message:
        'Az exportálást végre lehet hajtani a mai napra is, de nem garantált, hogy minden tranzakció megérkezett! Kérjük, válasszon régebbi dátumot vagy figyelmesen ellenőrizze a bankszámla egyenleget, hogy stimmel-e a záró érték!',
      className: 'bg-warning text-black',
    },
    [TOASTER_STATE.EXPORT_FILES_FAILED]: {
      title: 'Sikertelen exportálás',
      message: 'Az exportálás meghiúsult!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.AGGREG8_API_CONNECT_SUCCESS]: {
      title: 'Sikeres API öszekötés',
      message: 'Sikeresen csatlakoztatta az Aggreg8 fiókját az Adriana Connect-hez!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.AGGREG8_API_CONNECT_FAILED_OR_TIMEOUT]: {
      title: 'A csatlakozás valószínűleg meghiúsult',
      message:
        'A kapcsolat megadott idő alatt nem jött létre! Ez nem feltétlenül jelenti annak sikertelen voltát! Ha az oldal pár perc múlva sem frissül, próbálja meg újra! ',
      className: 'bg-warning text-black',
    },
    [TOASTER_STATE.AGGREG8_API_CONNECT_REVOKE_SUCCESS]: {
      title: 'Sikeres API visszavonás',
      message: 'Sikeresen visszavonta az Adriana Connect Aggreg8 hozáférését!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.AGGREG8_WAIT_FOR_RESPONSE]: {
      title: 'AGGREG8 Api csatlakozás',
      message: 'Ha a folyamat sikeresen lezajlott, az adatok pár perc múlva frissülnek!',
      className: 'bg-info text-black',
    },
    [TOASTER_STATE.UPLOADED_FILE_STATISTICS]: {
      title: 'Sikeres fájlfeltöltés',
      message: toasterMessage,
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.RECAPTCHA_WARNING]: {
      title: 'Hitelesítési probléma',
      message: 'Kérjük pipálja be a Nem vagyok robot melletti jelölőnégyzetet!',
      className: 'bg-warning text-black',
    },
    [TOASTER_STATE.EXPIRED_LINK]: {
      title: 'Lejárt vagy hibás link',
      message: 'A link, amivel be akar lépni, lejárt vagy érvénytelen! Kérjük jelentkezzen be újra!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.ACCESS_TOKEN_CREATION_FAILED]: {
      title: 'Hozzáférési kulcs létrehozása',
      message: 'A hozzáférési kulcs létrehozása nem sikerült!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.ACCESS_TOKEN_REVOKED_SUCCESS]: {
      title: 'Hozzáférési kulcs visszavonása',
      message: 'Sikeresen visszavonta a hozzáférési kulcsot!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.ACCESS_TOKEN_REVOKED_FAILED]: {
      title: 'Hozzáférési kulcs visszavonása',
      message: 'A hozzáférési kulcsot nem sikerült visszavonni!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.GET_ACCOUNTANT_LIST_BY_COMPANY_FAILED]: {
      title: 'A könyvelők listájának lekérése sikertelen',
      message: 'A könyvelők listájának lekérése sikertelen probálja ujra!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.ACCOUNT_SAVE_SUCCESS]: {
      title: 'Sikeres mentés',
      message: 'A számlát sikeresen mententük a céghez!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.ACCOUNT_SAVE_FAILED]: {
      title: 'Sikertelen mentés',
      message: 'A számla mentése sikertelen!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.BANK_CONFIG_SAVE_FAILED]: {
      title: 'Sikertelen mentés',
      message: 'A bank konfiguráció mentése sikertelen!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.BANK_CONFIG_SAVE_SUCCESS]: {
      title: 'Sikeres mentés',
      message: 'A bank konfiguráció mentése sikeres, a tranazckiók újra fognak populálódni(max 10 perc)!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.PRIVACY_UPDATE_FAILED]: {
      title: 'Sikertelen mentés',
      message: 'Az adatvédelmi nyilatkozat elfogadása sikertelen volt!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.PRIVACY_UPDATE_SUCCESS]: {
      title: 'Sikeres mentés',
      message: 'Az adatvédelmi nyilatkozat elfogadása megtörtént!',
      className: 'bg-success text-white',
    },
    [TOASTER_STATE.DELETE_COMPANY_FAILED]: {
      title: 'Sikertelen törlés',
      message: 'Nem sikerült a céget törölni!',
      className: 'bg-danger text-white',
    },
    [TOASTER_STATE.MOVE_COMPANY_FAILED]: {
      title: 'Sikertelen áthelyezés',
      message: 'A bankszámla áthelyezése meghiúsult!',
      className: 'bg-danger text-white',
    },
  };
  return { state };
};
